// @ts-ignore
export const all = (state) => {
  return state.all;
};

// @ts-ignore
export const one = (state) => state.one;

export const newArticle = (state: any) => state.newArticle;
